let Carousel = require('../components/Carousel');
let Http     = require('../components/Http');
let Popup    = require('../components/Popup');

class News {
    constructor() {
        new Carousel('.js-carousel-news', {
            type: 'size'
        });
        this._http  = new Http();
        this._main  = document.getElementsByTagName('main')[0];
        this._popup = new Popup('', 'js-carousel-popup-news');

        this._addListener();
    }

    _addListener() {
        let knowMoreButtons = document.getElementsByClassName('js-news-know-more');

        for (let btn of knowMoreButtons) {
            btn.addEventListener('click', () => {
                let id = btn.getAttribute('data-news');
                this._http.get('/extension/news/' + id, {}, false).then((response) => {
                    let popup = document.querySelector(btn.getAttribute('data-target'));
                    if (popup) {
                        this._main.removeChild(popup);
                    }

                    this._main.insertAdjacentHTML('beforeend', response);
                    popup = document.querySelector(btn.getAttribute('data-target'));
                    this._popup.open(popup);

                }).catch(() => {

                });
            });
        }
    }
}

module.exports = News;